import '../styles/contact.css'
import { faTiktok, faInstagram, faYoutube, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faEarthEurope, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fade } from 'react-awesome-reveal';

export default function Contact() {
    return (
        <main className="contact-page">
            <div className="contact-orb contact-orb--1" />
            <div className="contact-orb contact-orb--2" />

            <Fade direction="up" triggerOnce cascade damping={0.08}>
                <span className="contact-label">Get in touch</span>
                <h1 className="contact-title">Let's talk</h1>
                <p className="contact-subtitle">
                    Have a question, idea, or want to collaborate? Drop us a message.
                </p>
            </Fade>

            <div className="contact-grid">
                {/* Contact Form */}
                <Fade direction="up" triggerOnce>
                    <form
                        className="contact-form"
                        action="https://formsubmit.co/biancaappsdev@gmail.com"
                        method="post"
                    >
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input type="text" id="name" name="name" placeholder="Your name" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input type="email" id="email" name="email" placeholder="you@example.com" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea id="message" name="message" placeholder="Tell us about your idea..." rows="5" required></textarea>
                        </div>
                        <button className="contact-submit" type="submit">
                            Send Message
                        </button>
                    </form>
                </Fade>

                {/* Info side */}
                <Fade direction="up" delay={100} triggerOnce>
                    <div className="contact-info">
                        <div className="info-card">
                            <div className="info-card__icon">
                                <FontAwesomeIcon icon={faEnvelope} />
                            </div>
                            <div>
                                <h3>Email</h3>
                                <a href="mailto:biancaappsdev@gmail.com">biancaappsdev@gmail.com</a>
                            </div>
                        </div>

                        <div className="info-card">
                            <div className="info-card__icon">
                                <FontAwesomeIcon icon={faEarthEurope} />
                            </div>
                            <div>
                                <h3>Location</h3>
                                <span>Bacau, Romania</span>
                            </div>
                        </div>

                        <div className="contact-socials">
                            <h3>Follow us</h3>
                            <div className="contact-socials__row">
<a className="social--tiktok" href="https://www.tiktok.com/@eosrmg" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><FontAwesomeIcon icon={faTiktok} /></a>
                                <a className="social--instagram" href="https://www.instagram.com/eosrmg_developer/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} /></a>
                                <a className="social--youtube" href="https://www.youtube.com/channel/UCUzEYts1gAURebNLCcEtHoA" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FontAwesomeIcon icon={faYoutube} /></a>
                                <a className="social--github" href="https://github.com/eosrmg" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><FontAwesomeIcon icon={faGithub} /></a>
                            </div>
                        </div>
                    </div>
                </Fade>
            </div>
        </main>
    );
}
